import { render, staticRenderFns } from "./BbppProductosServiciosComex.vue?vue&type=template&id=d2230c5a"
import script from "./BbppProductosServiciosComex.vue?vue&type=script&lang=js"
export * from "./BbppProductosServiciosComex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports